import { isSafeAppPath } from './build-login-redirect-href';
/** Bounded session recovery events — no PII in payloads. */
export const SessionRecoveryEvent = {
    CsrfRenewStarted: 'session_recovery_csrf_renew_started',
    CsrfRenewSucceeded: 'session_recovery_csrf_renew_succeeded',
    CsrfRenewFailed: 'session_recovery_csrf_renew_failed',
};
export function sanitizeSessionRecoveryTelemetryPayload(payload) {
    const sanitized = { audience: payload.audience };
    if (typeof payload.operation === 'string' && payload.operation.length > 0 && payload.operation.length <= 80) {
        sanitized.operation = payload.operation;
    }
    if (payload.sessionErrorKind) {
        sanitized.sessionErrorKind = payload.sessionErrorKind;
    }
    if (typeof payload.redirectPath === 'string' && isSafeAppPath(payload.redirectPath)) {
        sanitized.redirectPath = payload.redirectPath;
    }
    return sanitized;
}
export function createSessionRecoveryTelemetryReporter(logger, reporter) {
    return (event, payload) => {
        const sanitized = sanitizeSessionRecoveryTelemetryPayload(payload);
        logger.info?.(event, sanitized);
        reporter?.(event, sanitized);
    };
}
//# sourceMappingURL=session-recovery-telemetry.js.map